
<template>
      <vs-dialog v-model="active" width="750px">
        <template #header>
          <h4 class="not-margin">
            Crear registro(s)
          </h4>
        </template>

        <div class="con-form">
            <vs-row>
                <vs-col w="6">
                    <div  @click="getCambioPestana('registro')" :class="estilosCambio == 'registro' ? 'estilosActivos' : 'estilosNoActivos'" class="text-center">
                        <h5>Registro individual</h5>
                    </div>
                </vs-col>
                <vs-col w="6">
                    <div  @click="getCambioPestana('masivo')" :class="estilosCambio == 'masivo' ? 'estilosActivos' : 'estilosNoActivos'" class="text-center">
                        <h5>Carga masiva</h5>
                    </div>
                </vs-col>
            </vs-row>
            <div v-show="botonRegistro">
                <vs-row>
                    <vs-col  w="12">
                        <registro class="mt-4" :ejecutar="ejecutar" :instituciones="instituciones" :filtros="filtros" :csrf_token="csrf_token" :aumentarInd="aumentarInd" @cerrarModal="cerrarMasivo"></registro>
                    </vs-col>
                </vs-row>
            </div>
            <div v-show="botonMasivo">
                <vs-row>
                    <vs-col  w="12">
                        <masivo class="mt-4" :aumentarMasi="aumentarMasi" :instituciones="instituciones" @cerrarModal="cerrarInd"></masivo>
                    </vs-col>
                </vs-row>
            </div>
        </div>
      </vs-dialog>
</template>
<script>
import registro from './registro-individual.vue'
import masivo from './carga-masiva.vue'
export default {
    props:[
        'value',
        'ejecutar',
        'instituciones',
        'filtros',
        'csrf_token'
    ],
    data:() => ({
        active: false,
        botonRegistro: true,
        botonMasivo: false,
        estilosCambio: 'registro',
        aumentarInd: 0,
        aumentarMasi: 0
    }),
    components:{
        registro,
        masivo
    },
    methods:{
        getCambioPestana(boton){
            if(boton == 'registro'){
                this.botonRegistro = true
                this.botonMasivo = false
                this.estilosCambio = 'registro'
            }
            if(boton == 'masivo'){
                this.botonRegistro = false
                this.botonMasivo = true
                this.estilosCambio = 'masivo'
            }
        },
        cerrarInd(valor){
            console.log(valor)
            this.aumentarInd += 1
            this.active = false
            if(valor == 'recargar'){
                this.$emit('refreshTable')
            }
        },
        cerrarMasivo(valor){
            console.log(valor)
            this.aumentarMasi += 1
            this.active = false
            if(valor == 'recargar'){
                this.$emit('refreshTable')
            }
        }
    },
    watch:{
        value (val) {
            this.active = val
        },      
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
    }
}
</script>

<style scoped>
.oblig{
    font-size: 0.7rem;
    margin-left: 3px;
}
.estilosActivos{
    color:#2471A3;
    border-bottom: 2px solid #2471A3;
    font-weight: bold;
    margin: 0 1%;
    cursor: pointer;
}
.estilosNoActivos{
    color:#CACFD2;
    font-weight: bold;
    margin: 0 1%;
    cursor: pointer;
}
</style>
